module.exports = __webpack_public_path__ + "static/media/price.5c59a27f.png";